import { toPersistedApplication } from '@/adapter/applicationLoader';
import { useApplication } from '@/hooks/useApplication';
import { PersistedApplication } from '@/types/application';
import { InputAdornment } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { FC, useEffect, useState } from 'react';

type FileExportProps = {
  open: boolean;
  onClose: () => void;
};

const FileExport: FC<FileExportProps> = (props) => {
  const { application } = useApplication();
  const [filename, setFilename] = useState<string>();

  const exportFile = () => {
    const data: PersistedApplication = {
      exported: new Date().toISOString(),
      ...toPersistedApplication(application)
    };
    const jsonData = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.download = `${filename}.json`;
    a.href = url;

    // Append the anchor to the body to ensure it works on Firefox.
    document.body.appendChild(a);

    // Programmatically click the link to start the download.
    a.click();

    // Clean-up: remove the anchor from the body and revoke the object URL.
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleExport = () => {
    exportFile();
    props.onClose();
  };

  useEffect(() => {
    if (!application.label) {
      setFilename(application.name);
      return;
    }
    setFilename(`${application.label} (${application.name})`);
  }, [props.open]);

  return (
    <Dialog open={props.open} onClose={props.onClose} disableRestoreFocus fullWidth>
      <DialogTitle>Export Application</DialogTitle>
      <DialogContent>
        <TextField
          label='filename'
          size='small'
          autoFocus={props.open}
          fullWidth
          value={filename}
          onChange={(event) => setFilename(event.target.value)}
          InputProps={{
            autoComplete: 'off',
            endAdornment: <InputAdornment position='end'>.json</InputAdornment>
          }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Cancel
        </Button>
        <Button onClick={handleExport} color='primary'>
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileExport;
